import { render } from "./categorynewComponent.vue?vue&type=template&id=ea8e4230"
import script from "./categorynewComponent.vue?vue&type=script&lang=js"
export * from "./categorynewComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\fronted-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__